import contratVenteApi from '@/api/contrat-vente.api'

const getDefaultState = () => {
  return {
    typesContrat: [],
    typesPrix: [],
    contractualisation: [],
    prixVenteAdherent: {},
    /*
     * Chargement TERMINE, qu'il ait abouti ou echoue. La carte "Ma treso
     * disponible" lit ce prix sans le charger : sans ce signal, un echec la
     * laissait attendre une reponse qui n'arriverait jamais.
     */
    prixVenteAdherentCharge: false,
    repartitionPrixVenteGroupe: {
      perso: {},
      quartiles: []
    },
    repartitionTypeContrat: {},
    repartitionTypeContratGroupe: {},
    filtreTypesContrats: [],
    evolutionPrixVenteAdherent: {},
    repartitionEvolutionPrixVenteGroupe: {
      perso: {},
      quartiles: []
    }
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    typesContrat (state) {
      return state.typesContrat
    },
    typesPrix (state) {
      return state.typesPrix
    },
    contractualisation (state) {
      return state.contractualisation
    },
    prixVenteAdherentCharge (state) {
      return state.prixVenteAdherentCharge
    },
    prixVenteAdherent (state) {
      return state.prixVenteAdherent
    },
    repartitionPrixVenteGroupe (state) {
      return state.repartitionPrixVenteGroupe
    },
    repartitionTypeContrat (state) {
      return state.repartitionTypeContrat
    },
    repartitionTypeContratGroupe (state) {
      return state.repartitionTypeContratGroupe
    },
    filtreTypesContrats (state) {
      return state.filtreTypesContrats
    },
    evolutionPrixVenteAdherent (state) {
      return state.evolutionPrixVenteAdherent
    },
    repartitionEvolutionPrixVenteGroupe (state) {
      return state.repartitionEvolutionPrixVenteGroupe
    }
  },

  mutations: {
    UPDATE_TYPES_CONTRAT (state, typesContrat) {
      state.typesContrat = typesContrat
    },
    UPDATE_TYPES_PRIX (state, typesPrix) {
      state.typesPrix = typesPrix
    },
    UPDATE_CONTRACTUALISATION (state, contractualisation) {
      state.contractualisation = contractualisation
    },
    DEBUT_CHARGEMENT_PRIX_VENTE_ADHERENT (state) {
      state.prixVenteAdherentCharge = false
    },
    UPDATE_PRIX_VENTE_ADHERENT (state, prixVenteAdherent) {
      state.prixVenteAdherent = prixVenteAdherent
      state.prixVenteAdherentCharge = true
    },
    UPDATE_REPARTITION_PRIX_VENTE_GROUPE (state, repartitionPrixVenteGroupe) {
      state.repartitionPrixVenteGroupe = repartitionPrixVenteGroupe
    },
    UPDATE_REPARTITION_TYPE_CONTRAT (state, repartitionTypeContrat) {
      state.repartitionTypeContrat = repartitionTypeContrat
    },
    UPDATE_REPARTITION_TYPE_CONTRAT_GROUPE (state, repartitionTypeContratGroupe) {
      state.repartitionTypeContratGroupe = repartitionTypeContratGroupe
    },
    UPDATE_FILTRE_TYPES_CONTRAT (state, filtreTypesContrats) {
      state.filtreTypesContrats = filtreTypesContrats
    },
    UPDATE_EVOLUTION_PRIX_VENTE_ADHERENT (state, evolutionPrixVenteAdherent) {
      state.evolutionPrixVenteAdherent = evolutionPrixVenteAdherent
    },
    UPDATE_EVOLUTION_REPARTITION_PRIX_VENTE_GROUPE (state, repartitionEvolutionPrixVenteGroupe) {
      state.repartitionEvolutionPrixVenteGroupe = repartitionEvolutionPrixVenteGroupe
    },
  },

  actions: {
    getTypesContrat ({ commit }) {
      return contratVenteApi.getTypesContrat()
        .then((response) => {
          commit('UPDATE_TYPES_CONTRAT', response)
        })
    },
    getTypesPrix ({ commit }) {
      return contratVenteApi.getTypesPrix()
        .then((response) => {
          commit('UPDATE_TYPES_PRIX', response)
          return response
        })
    },
    getContractualisation ({ commit, rootGetters }, codeTypeCulture) {
      const username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      return contratVenteApi.getContractualisation(username, anneeRecolte, codeTypeCulture)
        .then((response) => {
          commit('UPDATE_CONTRACTUALISATION', response)
          return response
        })
    },
    createOrUpdateContratVente ({ rootGetters }, contratVente) {
      const username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      if (contratVente.id != null) {
        if (contratVente.contratAgrial) {
          return contratVenteApi.updateRepartitionContratVente(username, contratVente.id, contratVente.cultures)
        } else {
          return contratVenteApi.updateContratVente(username, contratVente)
        }
      } else {
        return contratVenteApi.createContratVente(username, contratVente)
      }
    },
    deleteContratVente ({ dispatch, rootGetters }, contratVente) {
      const username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return contratVenteApi.deleteContratVente(username, contratVente.id)
        .then(() => {
          dispatch('getContractualisation', contratVente.cultures[0].typeCulture.code)
        })
    },
    getPrixVenteCulture ({ commit, rootGetters }, codeTypeCulture) {
      const username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      // Meme raison : un changement de graine doit remettre la carte
      // "Ma treso disponible" en attente.
      commit('DEBUT_CHARGEMENT_PRIX_VENTE_ADHERENT')
      return contratVenteApi.getPrixVenteCulture(username, anneeRecolte, codeTypeCulture)
        .then((response) => {
          commit('UPDATE_PRIX_VENTE_ADHERENT', response)
          return response
        })
        .catch(erreur => {
          // L'echec est signale avant d'etre relance : les cartes qui attendent
          // cette donnee sans la charger doivent cesser d'attendre.
          commit('UPDATE_PRIX_VENTE_ADHERENT', {})
          throw erreur
        })
    },
    construireResumeGroupeRepartitionPrixVente ({ commit, rootGetters }, params) {
      const username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return contratVenteApi.construireResumeGroupeRepartitionPrixVente(username, params)
        .then(result => {
          commit('UPDATE_REPARTITION_PRIX_VENTE_GROUPE', result)
          return result
        })
    },
    getRepartitionTypeContrat ({ commit, rootGetters }, codeGraine) {
      const username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      return contratVenteApi.getRepartitionTypeContrat(username, anneeRecolte, codeGraine)
        .then((response) => {
          commit('UPDATE_REPARTITION_TYPE_CONTRAT', response)
          return response
        })
    },
    getRepartitionTypeContratGroupe ({ commit, rootGetters }, { filtres, codeGraine }) {
      const username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      return contratVenteApi.getRepartitionTypeContratGroupe(username, anneeRecolte, codeGraine, filtres)
        .then((response) => {
          commit('UPDATE_REPARTITION_TYPE_CONTRAT_GROUPE', response)
          return response
        })
    },
    getFiltresTypeContrat ({ commit, rootGetters }, codeGraine) {
      const username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      return contratVenteApi.getFiltresTypeContrat(username, anneeRecolte, codeGraine)
        .then((response) => {
          commit('UPDATE_FILTRE_TYPES_CONTRAT', response)
          return response
        })
    },
    getEvolutionPrixVente ({ commit, rootGetters }, { codeTypeContrat, codeGraine }) {
      const username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      return contratVenteApi.getEvolutionPrixVente(username, anneeRecolte, codeGraine, codeTypeContrat)
        .then((response) => {
          commit('UPDATE_EVOLUTION_PRIX_VENTE_ADHERENT', response)
          return response
        })
    },
    construireResumeGroupeEvolutionRepartitionPrixVente ({ commit, rootGetters }, params) {
      const username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      return contratVenteApi.construireResumeGroupeEvolutionPrixVente(username, anneeRecolte, params)
        .then(result => {
          commit('UPDATE_EVOLUTION_REPARTITION_PRIX_VENTE_GROUPE', result)
          return result
        })
    },
  }
}

export default module
